import axios from 'axios'
import { RescheduleDto, TaskDto, UpdateTaskRequestBodyDto } from '../definition/booking.dto'
import { ENV } from '../initialization'
import { FilterQuery } from '../definition'
import { FinanceTaskStatus, ListFinanceTaskResponseDto } from '../definition/finance-task.dto'

const DOMAIN = ENV.BACKEND_PREFIX_URL

interface FinanceTasksFilterQuery extends FilterQuery {
  status?: FinanceTaskStatus
  startTime?: Date
  endTime?: Date
}

export const asyncGetFinanceTasks = async (data: FinanceTasksFilterQuery) => {
  const url = `${DOMAIN}/api/booking/finance-task`
  const response = await axios.get<ListFinanceTaskResponseDto>(url, {
    params: data
  })
  return response.data
}

export const asyncUpdateFinanceTask = async (
  id: string,
  data: {
    subject: string
    description?: string
  }
) => {
  const url = `${DOMAIN}/api/booking/finance-task/${id}`
  const response = await axios.put<TaskDto>(url, data)
  return response.data
}

export const asyncUpdateTaskStatus = async (id: string, status: FinanceTaskStatus) => {
  const url = `${DOMAIN}/api/booking/finance-task/${id}/update-status`
  const response = await axios.put<TaskDto>(url, { status })
  return response.data
}

export const asyncCreateFinanceTask = async (data: { subject: string; description?: string }) => {
  const url = `${DOMAIN}/api/booking/finance-task`
  const response = await axios.post<TaskDto>(url, data)
  return response.data
}

export const asyncDeleteFinanceTask = async (ids: string[]) => {
  const url = `${DOMAIN}/api/booking/finance-task`
  const response = await axios.delete<TaskDto>(url, {
    data: { ids }
  })
  return response.data
}

export const asyncGetTaskDetail = async (id: string) => {
  const url = `${DOMAIN}/api/booking/task/detail/${id}`
  const response = await axios.get<TaskDto>(url)
  return response.data
}

export const asyncSaveTask = async (data: UpdateTaskRequestBodyDto) => {
  const url = `${DOMAIN}/api/booking/task/update`
  const response = await axios.put<TaskDto>(url, data)
  return response.data
}

export const asyncRejectReschedule = async (id: string) => {
  const url = `${DOMAIN}/api/booking/task/reject-reschedule`
  const response = await axios.put<TaskDto>(url, { taskId: id })
  return response.data
}

export const asyncAcceptReschedule = async (data: RescheduleDto) => {
  const url = `${DOMAIN}/api/booking/task/accept-reschedule`
  const response = await axios.put<TaskDto>(url, data)
  return response.data
}
